/* Abnay WealthWise theme interactions */
(function () {
  function initMobileMenu() {
    var btn = document.querySelector('.nav-toggle');
    var menu = document.getElementById('mobile-menu');
    if (!btn || !menu || btn.dataset.abnayBound === 'true') return;
    btn.dataset.abnayBound = 'true';
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      btn.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
      if (open) { menu.classList.remove('open'); menu.setAttribute('hidden', ''); }
      else { menu.removeAttribute('hidden'); menu.classList.add('open'); }
    });
    menu.querySelectorAll('.mobile-link').forEach(function (a) {
      a.addEventListener('click', function () {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Open menu');
        menu.classList.remove('open');
        menu.setAttribute('hidden', '');
      });
    });
  }

  function initGlobe() {
    var svg = document.getElementById('dotGlobe');
    if (!svg || svg.dataset.abnayBuilt === 'true') return;
    svg.dataset.abnayBuilt = 'true';
    var W = 600, R = 240, cx = W / 2, cy = W / 2;
    var ns = 'http://www.w3.org/2000/svg';
    for (var lat = -88; lat <= 88; lat += 4) {
      var phi = (lat * Math.PI) / 180;
      var rRing = Math.cos(phi);
      var lonStep = Math.max(4, Math.round(8 / Math.max(rRing, 0.05)));
      for (var lon = 0; lon < 360; lon += lonStep) {
        var theta = (lon * Math.PI) / 180;
        var x = rRing * Math.sin(theta);
        var y = Math.sin(phi);
        var z = rRing * Math.cos(theta);
        if (z < -0.05) continue;
        var c = document.createElementNS(ns, 'circle');
        var depth = (z + 1) / 2;
        c.setAttribute('cx', (cx + R * x).toFixed(2));
        c.setAttribute('cy', (cy - R * y).toFixed(2));
        c.setAttribute('r', (0.6 + depth * 1.6).toFixed(2));
        c.setAttribute('fill', '#5A2785');
        c.setAttribute('opacity', ((0.10 + depth * 0.55) * 0.55).toFixed(2));
        svg.appendChild(c);
      }
    }
    var ring = document.createElementNS(ns, 'circle');
    ring.setAttribute('cx', cx); ring.setAttribute('cy', cy); ring.setAttribute('r', R + 2);
    ring.setAttribute('fill', 'none'); ring.setAttribute('stroke', 'rgba(190, 53, 137, 0.08)'); ring.setAttribute('stroke-width', '1');
    svg.appendChild(ring);
  }

  function initPanelTabs() {
    document.querySelectorAll('.tab-bar').forEach(function (bar) {
      if (bar.dataset.abnayTabs === 'true' || bar.closest('.compare-band')) return;
      bar.dataset.abnayTabs = 'true';
      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('.tab-btn');
        if (!btn) return;
        var tab = btn.getAttribute('data-tab');
        bar.querySelectorAll('.tab-btn').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        document.querySelectorAll('.tab-panel').forEach(function (p) {
          var on = p.id === 'panel-' + tab;
          p.classList.toggle('active', on);
          if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
      });
    });
  }

  function cycleSteps(selector) {
    var steps = document.querySelectorAll(selector);
    if (!steps.length || steps[0].dataset.abnayCycle === 'true') return;
    steps.forEach(function (s) { s.dataset.abnayCycle = 'true'; });
    var i = 0;
    setInterval(function () {
      steps.forEach(function (s, idx) { s.classList.toggle('active', idx === i); });
      i = (i + 1) % steps.length;
    }, 2400);
  }

  function initSebiModal() {
    var overlay = document.getElementById('sebi-overlay');
    var btn = document.getElementById('sebi-proceed');
    if (!overlay || !btn || overlay.dataset.abnayBound === 'true') return;
    overlay.dataset.abnayBound = 'true';
    function lockScroll() { document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; }
    function unlockScroll() { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }
    function dismiss() {
      overlay.style.transition = 'opacity 0.24s ease';
      overlay.style.opacity = '0';
      setTimeout(function () {
        overlay.setAttribute('hidden', '');
        overlay.style.opacity = '';
        overlay.style.transition = '';
        unlockScroll();
      }, 240);
    }
    lockScroll();
    setTimeout(function () { try { btn.focus(); } catch (e) {} }, 50);
    btn.addEventListener('click', dismiss);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) dismiss();
    });
  }

  function initCompareChart() {
    var bar = document.querySelector('.compare-band .tab-bar');
    if (!bar || bar.dataset.abnayCompare === 'true') return;
    bar.dataset.abnayCompare = 'true';
    var pathWith = document.getElementById('path-with');
    var pathWithout = document.getElementById('path-without');
    function setTab(name) {
      bar.querySelectorAll('.tab-btn').forEach(function (b) {
        var on = b.getAttribute('data-tab') === name;
        b.classList.toggle('active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (!pathWith || !pathWithout) return;
      if (name === 'with') { pathWith.style.opacity = '1'; pathWithout.style.opacity = '0.18'; }
      else if (name === 'without') { pathWith.style.opacity = '0.12'; pathWithout.style.opacity = '1'; }
      else { pathWith.style.opacity = '1'; pathWithout.style.opacity = '0.85'; }
    }
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.tab-btn');
      if (btn) setTab(btn.getAttribute('data-tab'));
    });
    setTab('with');
  }

  function init() {
    initMobileMenu(); initGlobe(); initPanelTabs(); cycleSteps('.approach-step'); cycleSteps('.analysis-step');
    initSebiModal(); initCompareChart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
